import type { TeamAssignment } from "../../lib/team";
import { shortDate, timeLabel } from "../../lib/team";

const STATUS: Record<string, { label: string; tone: string; hint: string }> = {
  wartet_auf_helfer: {
    label: "Antwort offen",
    tone: "warning",
    hint: "Die Einladung wartet auf Zu- oder Absage des Teammitglieds.",
  },
  wartet_auf_inhaber: {
    label: "Bewerbung offen",
    tone: "info",
    hint: "Das Teammitglied hat sich gemeldet; die Bauleitung muss entscheiden.",
  },
  zugesagt: {
    label: "Zugesagt",
    tone: "success",
    hint: "Der Personaleinsatz ist vereinbart.",
  },
  abgesagt_von_helfer: {
    label: "Vom Helfer abgesagt",
    tone: "danger",
    hint: "Für diesen Job muss gegebenenfalls Ersatz geplant werden.",
  },
  abgelehnt_von_helfer: {
    label: "Vom Helfer abgesagt",
    tone: "danger",
    hint: "Für diesen Job muss gegebenenfalls Ersatz geplant werden.",
  },
  abgelehnt_vom_inhaber: {
    label: "Bewerbung abgelehnt",
    tone: "muted",
    hint: "Die Bauleitung hat die Bewerbung abgelehnt.",
  },
};

export function MemberAssignments({ assignments }: {
  assignments: TeamAssignment[];
}) {
  return (
    <section className="team-card team-assignments">
      <header className="team-card-head">
        <div>
          <span className="team-section-label">Vor dem Job</span>
          <h2>Kommende Einsätze</h2>
        </div>
      </header>
      <p className="team-assignment-explainer">
        Hier steht nur, ob der Job vereinbart ist. Arbeitszeit und Lohn werden erst nach Ende des Einsatzes bestätigt.
      </p>
      <div className="team-assignment-list">
        {assignments.map((assignment) => {
          const status = STATUS[assignment.einladungs_status] ?? STATUS.wartet_auf_helfer;
          return (
            <article className="team-assignment-row" key={assignment.id}>
              <time dateTime={assignment.start_at}>
                <strong>{shortDate(assignment.start_at)}</strong>
                <span>{timeLabel(assignment.start_at)}–{timeLabel(assignment.end_at)}</span>
              </time>
              <div>
                <strong>{assignment.projekt_title || "Einsatz ohne Projektbezeichnung"}</strong>
                {assignment.note && <small>{assignment.note}</small>}
                <small>{status.hint}</small>
              </div>
              <span className={`team-pill ${status.tone}`}>{status.label}</span>
            </article>
          );
        })}
        {!assignments.length && (
          <div className="team-state"><p>Es gibt keine kommenden Einsätze.</p></div>
        )}
      </div>
    </section>
  );
}
